import { render, staticRenderFns } from "./OImage.vue?vue&type=template&id=45038940&"
import script from "./OImage.vue?vue&type=script&lang=js&"
export * from "./OImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports